import { Component } from '@angular/core';
import { Platform, NavController, MenuController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { AuthService } from './services/auth.service';
import * as firebase from 'firebase/app';
// new ones
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ChatService } from './services/chat.service';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    public navController: NavController,
    private platform: Platform,
    private storage: Storage,
    private authService: AuthService,
    //new ones
    private router: Router,
    private chatService: ChatService,
  ) {
    // Track last route
    this.trackLastRoute();
    this.initializeApp();
  }

  private trackLastRoute() {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        const url = e.urlAfterRedirects || e.url;
        // store without leading slash to match your existing 'home'/'login' usage
        const seg = url.replace(/^\//, '');
        if (seg && seg !== '' && seg !== 'login') {
          this.storage.set('lastRoute', seg);
        }
      });
  }

  async initializeApp() {
   
    this.platform.ready().then(() => {      
      this.storage.get('auth').then((val) => {
        if (val && val.Success) {
          if(val.Success){
            this.authService.APIKey = val.APIKey;

            this.authService.firstName = val.FirstName;
            this.authService.lastName = val.lastName;

            this.authService.userId = val.UserID;
            this.authService.clientId = val.ClientID;
            this.authService.employeeId = val.DriveEmployeeID;

            this.chatService.watchMessages();

            // Keep current route if it’s already set (deep link / refresh)
            const currentUrl = this.router.url; // e.g. '/feedback'
            const hasMeaningfulUrl = currentUrl && currentUrl !== '/' && currentUrl !== '/login';

            // Ensure session login time is set upon autologin
            this.storage.get('sessionLoginTime').then(ts => {
              if (!ts) {
                this.storage.set('sessionLoginTime', new Date().toISOString());
              }
            });

            if (hasMeaningfulUrl) {
              // Do nothing: keep current page
              return;
            }

            // A fresh app launch always starts on the home page.
            this.navController.navigateRoot('/home', { replaceUrl: true });

            //this.navController.navigateRoot('home');        
          }   
        } else {
          this.navController.navigateRoot('login');
        }
  
      })
    });

  }
}
